import { connect } from 'react-redux'
import { compose } from 'redux'
import { printToolSetWeek, setFlyerCurrentWeek, setNewspaperCurrentWeek } from '../../../actions'
import { FEATURES, FLYER_DATA, PRINT_WEEKS } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import ChooseWeek from '../present/ChooseWeek'
import { FLYER, NEWSPAPER, SHOWCASE, SHOWCASEPREVIEWMOVIE, SHOWCASEREDUCED, WEEKPOSTER } from '../../../constants/printType'

const mapStateToProps = state => ({
    weeks: getData(state, PRINT_WEEKS),
    features: getData(state, FEATURES),
    flyerServerData: getData(state, FLYER_DATA),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    printToolSetWeek: (week) => {
        if(SHOWCASE === ownProps.printType || WEEKPOSTER === ownProps.printType || SHOWCASEPREVIEWMOVIE === ownProps.printType || SHOWCASEREDUCED === ownProps.printType) {
            dispatch(printToolSetWeek(week))
        } else if (FLYER === ownProps.printType) {
            dispatch(setFlyerCurrentWeek(week))
        } else if (NEWSPAPER === ownProps.printType) {
            dispatch(setNewspaperCurrentWeek(week))
        }
    }
})

const ChooseWeekContainer = ({
    cinemaId,
    printType, 
    printID, 
    landscape,
    features, 
    weeks, 
    week,
    printPk,
    closePagePath,
    flyerServerData,
    printToolSetWeek,
}) => {
    return <ChooseWeek
        features={features}
        cinemaId={cinemaId}
        printType={printType}
        printID={printID}
        landscape={landscape}
        flyerServerData={flyerServerData}
        weeks={weeks}
        printPk={printPk}
        activeWeek={week}
        closePagePath={closePagePath}
        printToolSetWeek={printToolSetWeek}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ChooseWeekContainer)